import { removeEmpty } from "../array/removeEmpty";
import Cookies from "js-cookie";

export type ServiceItem = {
  skuId: string;
  itemId: string;
  quantity: number;
};

export type BasketItem = {
  itemPrice: string;
  itemId: string;
  productId: string;
  qty: string;
  services: Array<ServiceItem>;
  sku: string;
};

type Basket = {
  subTotal: string;
  product: BasketItem[];
};

export function getBasket(): Basket {
  const basketCookie = Cookies.get("cached_basket");

  if (!basketCookie) {
    return {
      subTotal: "0.00",
      product: [],
    };
  }

  const cookieSegments = basketCookie.split("^");

  return {
    subTotal: getSubTotal(cookieSegments),
    product: getBasketItems(cookieSegments),
  };
}

function getSubTotal(basketCookieSegments: string[]): string {
  const subTotalSegment = basketCookieSegments[basketCookieSegments.length - 2];

  const subTotal = subTotalSegment?.match(/\d+.\d+/)?.[0];
  if (!subTotal) {
    throw new Error("Basket cookie did not contain valid subtotal");
  }
  return subTotal;
}

function getBasketItems(basketCookieSegments: string[]): BasketItem[] {
  const itemSegments = basketCookieSegments.slice(0, -2);
  return removeEmpty(itemSegments.map(getBasketItem));
}

function getBasketItem(item: string): BasketItem | undefined {
  const data = item.split("|");

  const productId = data[1];
  const itemId = data[2];
  const sku = data[3];
  const itemPrice = data[4];
  const qty = data[5];

  const serviceField = data[6];
  const childServices = serviceField?.split("~") || [];

  const services = childServices.reduce(
    (
      services: Array<ServiceItem>,
      childService: string,
    ): Array<ServiceItem> => {
      const serviceElements = childService.split("-")?.reverse() || [];
      const quantity = parseInt(serviceElements[0] || "1");
      const serviceSkuId = serviceElements[2];
      const itemId = serviceElements.slice(3).reverse().slice(1).join("-");

      return serviceSkuId
        ? [...services, { skuId: serviceSkuId, itemId, quantity }]
        : services;
    },
    [],
  );

  if (!productId || !itemId || !sku || !itemPrice || !qty) return undefined;

  return {
    productId,
    itemId,
    sku,
    itemPrice,
    qty,
    services,
  };
}
